<template>
    <div>
        <universal-uploader
            @uploadSuccess="uploadSuccess"
            class="text-truncate"
            :clientAllowedFormats="['video']"
        >
            <b-btn pill variant="secondary" size="lg" block>
                <font-awesome-icon icon="fa-duotone fa-cloud-arrow-up" />
                Upload Video
            </b-btn>
        </universal-uploader>
    </div>
</template>

<script>
import UniversalUploader from "@/components/universalUploader/UniversalUploader";

export default {
    methods: {
        uploadSuccess(url) {
            this.$emit("uploaded", url);
        },
    },
    components: {
        UniversalUploader,
    },
};
</script>
